import React, { createContext, useContext, useState, ReactNode } from 'react';
import CaptionGenerationModal from '../../components/Modal/CaptionGenerationModal';

interface CaptionModalData {
  projectId: string;
  videoUrl: string;
  existingCaptions?: any[];
}

interface CaptionModalContextType {
  isOpen: boolean;
  modalData: CaptionModalData | null;
  openCaptionModal: (data: CaptionModalData) => void;
  closeCaptionModal: () => void;
}

const CaptionModalContext = createContext<CaptionModalContextType | undefined>(undefined);

interface CaptionModalProviderProps {
  children: ReactNode;
}

export const CaptionModalProvider: React.FC<CaptionModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState<CaptionModalData | null>(null);

  const openCaptionModal = (data: CaptionModalData) => {
    setModalData(data);
    setIsOpen(true);
  };

  const closeCaptionModal = () => {
    setIsOpen(false);
    setModalData(null);
  };

  return (
    <CaptionModalContext.Provider
      value={{
        isOpen,
        modalData,
        openCaptionModal,
        closeCaptionModal,
      }}
    >
      {children}
      <CaptionGenerationModal />
    </CaptionModalContext.Provider>
  );
};

export const useCaptionModal = () => {
  const context = useContext(CaptionModalContext);
  if (context === undefined) {
    throw new Error('useCaptionModal must be used within a CaptionModalProvider');
  }
  return context;
};